import React from 'react';

interface ApplicationOneIconProps {
  className?: string;
}

const ApplicationOneIcon: React.FC<ApplicationOneIconProps> = ({ className }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path d="M7 9.5L12 12.5L17 9.5M12 13V18M20.5 6.99985L12 2L3.5 6.99985V16.9999L12 22L20.5 16.9999V6.99985Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export default ApplicationOneIcon;